var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"elevation":"0"}},[_c('plotly',{ref:"graph",attrs:{"data":_vm.graph_data['data_render'],"layout":_vm.graph_data['layout_render'],"displayModeBar":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }